import { Component, OnInit, Input } from "@angular/core";
import { FIELDARRAY, FIELD, IFieldSchema } from "../../";

/**
 * Enum that will deal with determining what type of input the component should create
 */
export enum ModelType {
	none,
    text,
    number,
    boolean,
    date
}

@Component({
    selector: 'model',
    template:
        "<span [ngSwitch]=\"type\">"
            + "<input *ngSwitchCase=\"1\" type=\"text\" [(ngModel)]=\"model[key]\" placeholder=\"{{placeholder}}\" />"
            + "<input *ngSwitchCase=\"2\" type=\"number\" [(ngModel)]=\"model[key]\" placeholder=\"{{placeholder}}\" />"
            + "<span *ngSwitchCase=\"3\" class=\"ui checkbox\">"
                + "<input type=\"checkbox\" [(ngModel)]=\"model[key]\">"
                + "<label>{{placeholder}}</label>"
            + "</span>"
            + "<input *ngSwitchCase=\"4\" type=\"text\" [(ngModel)]=\"model[key]\" placeholder=\"{{placeholder}}\" />"
			+ "<span *ngSwitchDefault></span>"
        + "</span>"
})
export class ModelComponent implements OnInit {

	/**
	 * The type of model that should be created
	 */
    type: ModelType;
	/**
	 * If the model is required and should be sent into the angular 2 required API
	 */
    required: boolean;
	/**
	 * Two way binded model that will be used when binding to the input
	 */
    @Input() model: any;
	/**
	 * The key on the model that we should be using
	 */
    @Input() key: string;
	/**
	 * The placeholder that should be used in the inputs
	 */
    @Input() placeholder: string;

	/**
	 * Initialize the component once the application boots up
	 */
    ngOnInit() {
        this.key = this.key.replace(/[\'|\"]/g, '');
        let field = this.getField();

		this.type = ModelType.none;
		if (field !== null) {
			switch(field.type) {
				case String:
					this.type = ModelType.text;
					break;
				case Number:
					this.type = ModelType.number;
					break;
				case Boolean:
					this.type = ModelType.boolean;
					break;
				case Date:
					this.type = ModelType.date;
					break;
			}
		}
    }

	/**
	 * Helper method that will get the field schema to build out this model
	 *
	 * @return IFieldSchema
	 *   Will return a field schema used to build out the HTML input
	 */
    private getField(): IFieldSchema {
        let fieldArray = Reflect.getMetadata(FIELDARRAY, this.model, this.key);
        if (fieldArray !== undefined) {
            let field: IFieldSchema = Reflect.getMetadata(FIELD, this.model, this.key);
            field.type = fieldArray;
            return field;
        }

        let field: IFieldSchema = Reflect.getMetadata(FIELD, this.model, this.key);
        if (field !== undefined) {
            return field;
        }
        return null;
    }
}